import React, { useEffect, useState } from 'react'
import { addDisclaimantValidation } from '../../requests/createCase';
import { ErrorStatus } from '../FormStatus';
import { InputField } from '../Input';

export default function DefendantModal({ onClose, initState, onSubmit }) {

    const [errors, setErrors ] = useState([]);

    const [formState, setFormState] = useState({
        name: '',
        email: '',
        phone: '',
    });


    const cancelCreation = () => {
        setFormState({
            name: '',
            email: '',
            phone: '',
        })
        onClose();
    }


    useEffect(() => {
        if (initState !== {}) {
            let stateInit = {
                name: initState.name,
                email: initState.email,
                phone: initState.phone
            }
            setFormState(stateInit);
        }
    }, [])

    const handleInputChamge = (val, name) => {
        formState[name] = val;
    }

    const submitForm = async () => {
        await addDisclaimantValidation.validate(formState).then(() => {
            onSubmit(formState);
            cancelCreation();
        }).catch((e) => {
            setErrors(e.errors)
        })
    }

  return (
    
    <div className="fixed animate__animated animate__fadeIn w-screen h-screen modal-dialog-bg z-20 shadow-md md:px-8 px-4 top-0">
        <div className="relative w-full flex h-full justify-center items-center">
            <div className="lg:w-2/5 px-8 w-full bg-white py-8 rounded-xl">

                  <form onSubmit={(e) => {
                      e.preventDefault();
                      submitForm();
                  }}>
                      <h4 className="mb-4 text-lg font-semibold">Add Defendant </h4>
                      {errors.length > 0 && <ErrorStatus errors={errors} />}
                      <div className="mb-6">
                          <InputField
                              onChange={(e) => {
                                  setErrors([]);
                                  handleInputChamge(e.target.value, 'name')
                              }}
                              isRequired={true} type="text" placeholder="Mike Jones" name="fullname" defaultValue={formState.name} label="Defendant's Full name" />
                          <InputField
                              onChange={(e) => {
                                  setErrors([]);
                                  handleInputChamge(e.target.value, 'email')
                              }}
                              isRequired={true} type="email" placeholder="example@domain.com" defaultValue={formState.email} name="email" label="Defendant's Email" />

                          <InputField isRequired={true} type="text" placeholder="+1 8806 0098" onChange={(e) => {
                              setErrors([]);
                              handleInputChamge(e.target.value, 'phone')
                          }} defaultValue={formState.phone} name="phone" id="phone" label="Phone" />

                      </div>

                      <div className="flex text-xs font-semibold gap-3">
                          <button onClick={cancelCreation} className="w-1/2 text-red-800 border-red-800 hover:border-red-900 py-2 flex justify-center items center border-2 rounded-lg ">
                              <span>
                                  Close
                              </span>
                          </button>
                          <button className="w-1/2 py-2 flex justify-center items center border-2 border-blue-800 text-white bg-blue-800 hover:bg-blue-900 rounded-lg ">
                              <span>
                                  Submit
                              </span>
                          </button>
                      </div>
                  </form>
            </div>
        </div>
    </div>
  )
}
